var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',{staticClass:"logo",attrs:{"src":_vm.logoSrc,"width":_vm.size,"height":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }